import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
    selector: 'sc-svg',
    imports: [NgClass],
    templateUrl: './svg.component.html'
})
export class SvgComponent {
  name = input<string>(null);
  class = input<string>('size-5');
  size = input<string>('size-5');
}
